import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import { __RECAPTCHA_SITE_KEY__ } from "@/shared/config";

export const GoogleRecaptchaProvider = ({ children }: { children: React.ReactNode }) => {
    return (
        <GoogleReCaptchaProvider reCaptchaKey={__RECAPTCHA_SITE_KEY__ || ""}>
            {children}
        </GoogleReCaptchaProvider>
    );
};
